import { createContext } from 'react';
import type { Locale } from './config';

export interface LocaleContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

/**
 * Kept in its own module rather than beside the provider: a file that exports
 * both a component and a context loses React Fast Refresh, so every locale
 * change during development would remount the tree instead of updating it.
 */
export const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);
